export default __webpack_public_path__ + "static/media/upload-onedrive.9bd1e297.svg";